import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Field, Formik } from 'formik';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import * as Yup from 'yup';

import {
  GQLAccessorySize,
  GQLMaterialType,
  GQLParty,
  GQLPieceConfigurationInput,
  GQLPieceModelInput,
  GQLPieceSize,
  GQLPlatingType,
  GQLStonesPlacementType
} from '@jewelutions/core-crm-server-api-client-domain';

import { JwlField, JwlSelect } from '../../../../components';
import { SelectOption } from '../../../../components/JwlSelect/JwlSelect';
import { stringListToDisplayValueList } from '../../../../core/utils';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ErrorMessage } from '../../../../types-hack';

interface IProps {
  party: GQLParty;
  pieceId: string;
  onClose: (success: boolean) => void;
}

const availableStones: SelectOption[] = stringListToDisplayValueList(Object.values(GQLStonesPlacementType));
const availableAccessorySizes: SelectOption[] = stringListToDisplayValueList(Object.keys(GQLAccessorySize));

const PieceModelCreateDialog: React.FC<IProps> = ({ party, pieceId, onClose }) => {
  const [createPieceModel, { error, loading }] = GQLOperationBuilder.piece.createPieceModel();

  const initialValues = {
    sizeType: GQLPieceSize.Small,
    stonesPlacementType: GQLStonesPlacementType.NoStones,
    dimensions: {
      width: 1,
      height: 1,
      depth: 1
    }
  };

  const validationSchema = Yup.object({
    // name: Yup.string().required('Name is required')
  });

  const onSubmit = (props: any) => {
    const defaultConfiguration: GQLPieceConfigurationInput = {
      sizeType: props.sizeType,
      materialType: GQLMaterialType.Silver,
      platingType: GQLPlatingType.Rhodium,
      stonesPlacementType: props.stonesPlacementType
    };
    const input: GQLPieceModelInput = {
      availableConfigurations: [defaultConfiguration],
      dimensions: {
        width: props.dimensions.width,
        height: props.dimensions.height,
        depth: props.dimensions.depth
      },
      stonesPlacementType: props.stonesPlacementType,
      sizeType: props.sizeType,
      weights: [
        {
          configuration: defaultConfiguration,
          weightInGrams: 0
        }
      ]
    };

    const mutationVariables = { input: input, pieceId: pieceId };

    createPieceModel({ variables: mutationVariables }).then(_result => {
      onClose(true);
    });
  };

  return (
    <Dialog open aria-labelledby="model-dialog">
      <DialogTitle>{`Create piece model`}</DialogTitle>
      <DialogContent>
        <div>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ values, handleSubmit }) => (
              <form onSubmit={handleSubmit} className="flex flex-col">
                <Field
                  name="sizeType"
                  component={JwlSelect}
                  label="Size Type"
                  options={availableAccessorySizes}
                />
                <ErrorMessage component="span" name="sizeType" className="fs-12 text-error" />

                <Field
                  name="stonesPlacementType"
                  component={JwlSelect}
                  label="Stone Placement Type"
                  options={availableStones}
                />

                <ErrorMessage component="span" name="stonesPlacementType" className="fs-12 text-error" />

                <div style={{ height: '200px' }}>
                  <span>Dimensions</span>
                  <Field name="dimensions.height" component={JwlField} label="Height" />
                  <ErrorMessage component="span" name="dimensions.height" className="fs-12 text-error" />

                  <Field name="dimensions.width" component={JwlField} label="Width" />
                  <ErrorMessage component="span" name="dimensions.width" className="fs-12 text-error" />

                  <Field name="dimensions.depth" component={JwlField} label="Depth" />
                  <ErrorMessage component="span" name="dimensions.depth" className="fs-12 text-error" />
                </div>

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false)}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PieceModelCreateDialog;
